// TODO: Remove duplication with pp_shared_v2

export const convertArrayToObject = (items) => {
  const entities = {};
  const ids = [];

  items.forEach((item) => {
    const { poId } = item;
    if (poId in entities) {
      throw Error(`There is a duplicated poId ${poId} in the list.`);
    }
    entities[poId] = item;
    ids.push(poId);
  });

  return { entities, ids };
};

export const updateItem = ({ entities, ids }, item) => {
  const itemId = item.poId;
  if (!ids.includes(itemId)) {
    throw Error(
      `Item with id ${itemId} does not exists in list, please use addItem function`,
    );
  }
  const newEntities = {
    ...entities,
    [itemId]: {
      ...entities[itemId],
      ...item,
    },
  };
  return {
    entities: newEntities,
    ids,
  };
};

export const addItem = ({ entities, ids }, item, addToStart = false) => {
  const itemId = item.poId;
  if (ids.includes(itemId)) {
    return updateItem({ entities, ids }, item);
  }
  let newIds;
  if (addToStart) {
    newIds = [itemId, ...ids];
  } else {
    newIds = [...ids, itemId];
  }
  return {
    entities: {
      ...entities,
      [itemId]: item,
    },
    ids: newIds,
  };
};

export const toList = ({ entities, ids = [] }) => {
  return ids.map((id) => entities[id]);
};
